// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../../../node_modules/css-loader/index.js?{\"sourceMap\":true}!../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"id\":\"data-v-b51464ac\",\"scoped\":true,\"sourceMap\":false}!../../../../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./VimeoPlayer.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("8dc93d40", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-b51464ac","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/main/frontend/vue/js/modules/pro/project/components/VimeoPlayer.vue
// module id = idqR
// module chunks = 1 2 3 4 5 6 8 9 10 11 12